import { Component, Input } from '@angular/core';
import { UserContext } from '@core/models';
import { ScreenSizeService } from '@core/services';
import { DashboardService } from '@dashboard/dashboard.service';
import { fadeInOut } from '@shared/animations';
import { Clients } from '@shared/enums';
import * as ProgramCodeThemeConstants from '@core/constants/program-code-theme-constants';
import * as ProgramCodeConstants from '@core/constants/program-code-constants';

//* Third party
import * as Highcharts from 'highcharts';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import rounded from 'highcharts-rounded-corners';
rounded(Highcharts);
interface ChartOptions {
  bar: Highcharts.Options;
  pie: Highcharts.Options;
}

@Component({
  selector: 'sp-dashboard-charts',
  template: `
    <!-- //? Bar Chart -->
    <highcharts-chart
      *ngIf="isMobile$ | async"
      [Highcharts]="Highcharts"
      [options]="highchartsOptions.bar"
      style="width: 100%; height: auto; display: block; margin: 0 auto">
    </highcharts-chart>

    <!-- //? Pie Chart -->
    <highcharts-chart
      *ngIf="!(isMobile$ | async)"
      [Highcharts]="Highcharts"
      [options]="highchartsOptions.pie"
      style="width: 100%; height: auto; display: block; margin: 0 auto">
    </highcharts-chart>
  `,
  animations: [fadeInOut],
})
export class DashboardChartsComponent {
  //* Required For Highcharts
  Highcharts: typeof Highcharts = Highcharts;

  //* ScreenSize Observable
  isMobile$ = this.screenSizeService.isMobile$;
  highchartsOptions: ChartOptions;

  @Input() userContext: UserContext;
  @Input() set chartOptions(val: ChartOptions) {
    this.highchartsOptions = val;

    const programCode = this.userContext.programCode.toLowerCase();
    if (ProgramCodeConstants.SurepayrollProgramCodeConstants.indexOf(programCode) >= 0) {
      this.highchartsOptions.pie.colors = ProgramCodeThemeConstants.SurepayrollGraphThemeColors;
      this.highchartsOptions.bar.colors = ProgramCodeThemeConstants.SurepayrollBarThemeColors;
    } else if (ProgramCodeConstants.PaychexProgramCodeConstants.indexOf(programCode) >= 0) {
      this.highchartsOptions.pie.colors = ProgramCodeThemeConstants.PaychexGraphThemeColors;
      this.highchartsOptions.bar.colors = ProgramCodeThemeConstants.PaychexBarThemeColors;
    } else if (ProgramCodeConstants.TruistProgramCodeConstants.indexOf(programCode) >= 0) {
      this.highchartsOptions.pie.colors = ProgramCodeThemeConstants.TruistGraphThemeColors;
      this.highchartsOptions.bar.colors = ProgramCodeThemeConstants.TruistBarThemeColors;
    } else if (ProgramCodeConstants.RunpayrollProgramCodeConstants.indexOf(programCode) >= 0) {
      this.highchartsOptions.pie.colors = ProgramCodeThemeConstants.RunpayrollGraphThemeColors;
      this.highchartsOptions.bar.colors = ProgramCodeThemeConstants.RunpayrollBarThemeColors;
    }
  }

  constructor(private screenSizeService: ScreenSizeService) {}
}
